function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "29",
  height: "28",
  viewBox: "0 0 282 290",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  imageRendering: "optimizeQuality",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "id0",
  gradientUnits: "userSpaceOnUse",
  x1: "136.97",
  y1: "282.882",
  x2: "136.97",
  y2: "7.739"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#4a3d52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".188",
  stopColor: "#4f3b50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".451",
  stopColor: "#942b45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".549",
  stopColor: "#dd1b38"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".788",
  stopColor: "#e41b39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#eb1c3a"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65 25C45 38 30 55 18 73l-3 6v2c-3 5-5 10-6 16-32 97 26 175 106 189 48 9 95-7 127-38 3-3 34-36 32-66-16 29-52 51-96 59h-2c-10 1-19 2-29 2-35 0-64-9-85-24-23-13-40-32-48-53 15 20 40 37 70 46-16-15-26-37-26-62 0-20 6-37 16-51l1-1c2-3 4-5 6-8 12-12 26-20 43-23 17-6 37-7 55-6 42 3 61 21 65 25 1-1 3-3 4-7 4-8 4-20 4-20 2 4 3 9 3 14 0 4-1 8-2 11 0 2-1 3-1 4-21 47-104 45-133 35-2-1-5-2-7-3 0-1-1-1-1-1-8-4-15-10-20-17-9 19-10 38-9 52 2 10 8 20 18 25 29 16 69 16 92 12 22-3 41-13 56-32 15-18 20-38 21-55 0-11 0-27-9-43-4-7-11-14-17-20-7-7-24-20-41-28-18-8-38-11-58-11-27 0-55 7-79 23z",
  fill: "url(#id0)",
  id: "_2388076633088"
})));